import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';
import uploadingStatuses from 'shared/constants/uploading-statuses';

import { getVideoWithChannelDataById } from 'shared/selectors/videos';

import { normalizeVideo } from 'shared/redux/helpers/normalized';
import { subscribeOnProgressUpdate } from 'dashboard/utils/progress-update-utils';
import getCatalogCallbackUrl from 'dashboard/utils/get-catalog-callback-url';

import { toFakeVideoData, addDataToSameChannelVideos } from 'dashboard/redux/helpers/upload';
import { UPLOAD_EVENTS } from './upload-events';


const ACTIONS = createAsyncActions('SERVER.VIDEO.REUPLOAD', ['START', 'PROGRESS', 'SUCCESS', 'FAIL']);
export const NAMES = ACTIONS.NAMES;
const { START, PROGRESS, SUCCESS, FAIL } = ACTIONS;


export default function reupload(id, file, analytics) {
  return function (dispatch, getState) {
    const state = getState();
    const { vodSettings } = state;
    const { defaultChannelId } = vodSettings;
    const videoData = getVideoWithChannelDataById(state, id);

    const uploadPromise = vodAdapter.item.reupload({
      file,
      updateUrl: videoData.updateUrl || getCatalogCallbackUrl(id),
      itemId: id,
      listId: defaultChannelId,
    });

    const fakeVideoData = _.pick(toFakeVideoData(file), ['uploadingStatus', 'uploadedSize', 'fileSize']);

    const { on, off } = uploadPromise;
    const uploadKey = Symbol('upload-key');
    const data = { ...videoData, ...fakeVideoData, on, off };
    const normalizedData = normalizeVideo(data);
    analytics = { uploadPromise, uploadKey, ...analytics };
    addDataToSameChannelVideos(normalizedData, getState());
    dispatch(START(data, { data: normalizedData }, {
      analytics: {
        type: UPLOAD_EVENTS.START_ATTEMPT,
        payload: analytics,
      },
    }));

    subscribeOnProgressUpdate(uploadPromise, function ({ uploadingStatus }) {
      // TODO: move to video and channelVideo reducers, subscribed to all ACTIONS
      const data = normalizeVideo({
        id,
        uploadingStatus,
      });
      addDataToSameChannelVideos(data, getState());

      dispatch(PROGRESS(fakeVideoData, { data }));
    });

    return uploadPromise
      .then(
        function (response) {
          response = {
            ...response,
            // mark item as newly created
            data: normalizeVideo({ ...response.data, isNew: true }),
          };
          addDataToSameChannelVideos(response.data, getState());

          dispatch(SUCCESS(fakeVideoData, response, {
            analytics: {
              type: UPLOAD_EVENTS.SUCCESS,
              payload: analytics,
            },
          }));
          return response;
        },

        function (response) {
          const { status, error } = response;
          const data = normalizeVideo({
            id,
            error,
            uploadingStatus: uploadingStatuses.FAILED,
          });
          addDataToSameChannelVideos(data, getState());
          dispatch(FAIL(fakeVideoData, { ...response, data }, {
            analytics: [
              { type: UPLOAD_EVENTS.FAIL, payload: analytics },
              {
                type: 'detailed-error',
                payload: { name: 'upload-error', errorData: response },
              },
              status > 500 || !error ? { type: 'error', payload: { name: 'dashboard.video.reupload' } } : null,
            ],
          }));
          return response;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/video/reupload.js